import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';

const DisclaimerModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const hasAccepted = sessionStorage.getItem('disclaimerAccepted');
    if (!hasAccepted) {
      onOpen();
    }
  }, [onOpen]);

  const handleAccept = () => {
    sessionStorage.setItem('disclaimerAccepted', 'true');
    onClose();
  };

  const handleDiscard = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      /* Background scroll allow karne ke liye niche wale props zaroori hain */
      trapFocus={false}
      blockScrollOnMount={false}
      hasCloseButton={false}
      /* Modal ko screen ke niche lane ke liye motion preset aur size */
      motionPreset="slideInBottom"
    >
      {/* ModalOverlay ko remove kar diya hai taaki background click/scroll ho sake */}
      <ModalContent
        position="fixed"
        bottom="0"
        m={0}
        borderRadius="none" // Bottom bar jaisa dikhne ke liye
        maxW="100vw"
        boxShadow="0 -4px 12px rgba(0,0,0,0.15)"
        fontFamily=" serif"
      >
        <ModalHeader
          textAlign="start"
          borderBottomWidth="1px"
          color="red.600"
          py={3}
        >
          Disclaimer
        </ModalHeader>
        <ModalBody py={4}>
          <Text fontSize="sm" textAlign="justify" lineHeight="tall">
            Neo Law is a specialised corporate and legal consulting firm
            headquartered in Vadodara, Gujarat, with a focus on strategic legal
            advisory across corporate transactions, startup consulting,
            corporate restructuring, venture capital investment structuring, and
            regulatory advisory. The firm is built on the foundation of
            precision, commercial foresight, and enforceability, offering
            tailored solutions to businesses navigating complex legal
            landscapes, with a customised approach towards SMEs.
          </Text>
        </ModalBody>
        <ModalFooter justifyContent="start" gap={4} pb={6}>
          <Button
            colorScheme="red"
            variant="outline"
            onClick={handleDiscard}
            flex={{ base: 1, md: 'none' }}
            minW="120px"
          >
            Discard
          </Button>
          <Button
            colorScheme="red"
            onClick={handleAccept}
            flex={{ base: 1, md: 'none' }}
            minW="120px"
          >
            Accept
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DisclaimerModal;
